<div class="pick-list-container">
	<div class="pick-list-header">
		<h2 class="title">{{ getTitle }}</h2>
		<button pButton icon="far fa-plus-circle"
				[disabled]="control.disabled"
				*ngIf="field.UIOptions?.PickListOptions?.showAddAction" class="p-button-success new-picklist-option" label="New"
				(click)="showNewItemDialog()"></button>
	</div>

	<div class="pick-list-body">
		<p-pickList
			sourceHeader="Available"
			targetHeader="Selected"
			filterBy="label"
			sourceFilterPlaceholder="Search by name"
			targetFilterPlaceholder="Search by name"
			[source]="sourceData"
			[target]="targetData"
			[dragdrop]="field.UIOptions?.PickListOptions?.dragdrop || false"
			[responsive]="true"
			[sourceStyle]="{'height':'30rem'}"
			[targetStyle]="{'height':'30rem'}"
			[showSourceControls]="field.UIOptions?.PickListOptions?.showSourceControls || false"
			[showTargetControls]="field.UIOptions?.PickListOptions?.showTargetControls || false"
			[stripedRows]="true"
			(onMoveToTarget)="onMoveToTarget($event)"
			(onMoveAllToTarget)="onMoveAllToTarget($event)"
			(onMoveToSource)="onMoveToSource($event)"
			(onMoveAllToSource)="onMoveAllToSource($event)"
			[disabled]="control.disabled"
			[styleClass]="field.customClass"
		>
			<ng-template let-type pTemplate="item">
				<div class="type-item">
					<p>{{ type.label}}</p>
					<div class="actions" *ngIf="!control.disabled">
						<button
							*ngIf="field.UIOptions?.PickListOptions?.showDelete"
							pButton
							pRipple
							type="button"
							class="p-button-rounded p-button-danger"
							(click)="removeItem($event, type)">
							<i class="far fa-trash"></i>
						</button>
						<button pButton pRipple type="button" class="p-button-rounded" *ngIf="field.UIOptions?.PickListOptions?.showEdit" (click)="editItem(type)"><i class="far fa-pencil"></i></button>
					</div>
				</div>
			</ng-template>
		</p-pickList>
	</div>
</div>
